import { lazy } from 'react';

// Panel children — mounted under the shared AppLayout route by ./index.js
export const accountPanelRoutes = [
  {
    exact: true,
    path: '/accounts/change-password',
    component: lazy(() => import('pages/accounts/AccountPasswordUpdatePage')),
  },
  {
    exact: true,
    path: '/accounts/profile',
    component: lazy(() => import('pages/accounts/AccountUserProfilePage')),
  },
  {
    exact: true,
    path: '/accounts',
    component: lazy(() => import('pages/accounts/AccountPage')),
  },
];
